import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import * as UserActions from '../../../../store/actions/user.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as PromoVouchersAction from '@ibe/store/actions/promo-vouchers.actions';

import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
import { INDRALocationService } from '@ibe.services/location.indra.service';
import { Location } from '@angular/common';

import {	
	DEFAULT_LANGUAGE, 
	DEFAULT_MARKET
} from '@ibe.config';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { INDRADiscountService } from '@ibe.services/discount.indra.service';

@Component({
  selector: 'app-market-language',
  templateUrl: './market-language.indra.component.html',
  styleUrls: ['./market-language.component.scss']
})
export class INDRAMarketLanguageComponent implements OnInit, OnDestroy {
	isAlive = true;

	infoLoading: boolean;
	headerLoading: boolean;

	selectedCountryIndex;
	selectedLanguageIndex;
	selectedLanguageCode: string;
	selectedMarketCode: string;
	currencyChecked: boolean = false;
	// disabledPage = ["change-flight", "cancel-booking", "upgrade-with-cash", "purchase"]
	// disableMarket = false;

	showCountry: boolean;

	private loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
	private country$: Observable<number> = this.store.select(fromStore.getUserCountry);
	private language$: Observable<number> = this.store.select(fromStore.getUserLanguage);
	private promoCodesAndVoucher$: Observable<any> = this.store.select(fromStore.getSelectedPromoVouchers);
	private confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	
	// private miles$: Observable<string> = this.store.select(fromStore.getOptionsBarPriceUnit);

	countriesList = [];
	promoCodesAndVoucher = [];
	// countriesList = [
	// 	{
	// 		image: 'flags--flag-brazil',
	// 		country: 'Brazil',
	// 		code: 'BR',
	// 		language: [{ label: 'English', code: 'en' }, { label: 'Português', code: 'pt' }]
	// 	},
	// 	{
	// 		image: 'flags--flag-portugal',
	// 		country: 'Portugal',
	// 		code: 'PT',
	// 		language: [{ label: 'English', code: 'en' }, { label: 'Português', code: 'pt' }]
	// 	},
	// 	{
	// 		image: 'flags--flag-spain',
	// 		country: 'Spain',
	// 		code: 'ES',
	// 		language: [{ label: 'English', code: 'en' }, { label: 'Português', code: 'pt' }]
	// 	},
	// ];
	
	countryCurrencyList = [];
	
	allSubscriptions: Subscription[] = [];
	getMarketSubscription: Subscription;
	setMarketSubscription1: Subscription;
	setMarketSubscription2: Subscription;
	currencySubscription: Subscription;
	removeVoucherSubscription: Subscription;
	removePromocodeSubscription: Subscription;
	previousCountryIndex: any;
	previousLanguageIndex: any;
	confirmModalCallback = '';
	selectedCountry: any;
	languageRollback: boolean = false;
	changeLanguage: boolean = false;

	constructor(
		protected sidebarService: SidebarService, 
		private store: Store<fromStore.State>,
		private ibeAdminService: INDRAIbeAdminService,
		private languageMarketService: INDRALanguageMarketService,
		private locationService: INDRALocationService,
		private modalService: ModalService,
		private discountService: INDRADiscountService,
		private location: Location,
	) {
		//this.miles$
		//	.pipe(takeWhile(() => this.isAlive))
		//	.subscribe(value => {
		//	this.showCountry=!(value==='miles');
		//});
		
		this.isAlive = true;
		this.infoLoading = true;
		this.headerLoading = true;
		
		this.selectedMarketCode = sessionStorage.getItem('market');
		this.selectedLanguageCode = sessionStorage.getItem('language');
	 }

	ngOnInit() {
		this.loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.headerLoading = value;
		});

		this.country$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.selectedCountryIndex = value;
		});

		this.language$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.selectedLanguageIndex = value;
		});
		
		
		if (this.countriesList.length === 0) {
			this.headerLoading = true;
		}

		this.promoCodesAndVoucher$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.promoCodesAndVoucher = value;
		});
		
		this.confirmModalCallback$
		.pipe(takeWhile(() => this.isAlive))
		.subscribe(value => {
			if (value) {
				this.confirmModalCallback = value;
			}
			});

		this.currencySubscription = this.languageMarketService.getCurrency().subscribe(countryList => {
			this.countryCurrencyList = countryList;
			
			this.getMarketSubscription = this.languageMarketService.getMarkets().subscribe(markets => {

				const languages = this.languageMarketService.getLanguages(markets);
				this.countriesList = this.languageMarketService.getCountryList(markets, languages);
				if (this.countriesList) {
					this.headerLoading = false;
				}
				if (this.selectedMarketCode) {
					this.selectedCountryIndex = this.countriesList.findIndex(country => country.code === this.selectedMarketCode);					
				} else {
					const defaultlangMarket = this.languageMarketService.loadDefaultLanguageMarket();
					this.languageMarketService.getMarkets().subscribe((data)=>{
						const market= data.find((item => item.marketCode === defaultlangMarket[1]));
						if(market){
							this.setMarketSubscription1 = this.locationService.INDRA_setBookingMarket(market.marketCode, market.locales[0]).subscribe();
							this.languageMarketService.setMarket(market.marketCode);
							this.languageMarketService.setLanguage(market.locales[0]);
						}else{
							this.selectedCountryIndex =  this.countriesList.findIndex(country => country.code === DEFAULT_MARKET);
							if (this.selectedCountryIndex > 0) {

								const selectedLanguageCode = this.countriesList[this.selectedCountryIndex].language[0].code;
								this.setMarketSubscription1 = this.locationService.INDRA_setBookingMarket(this.countriesList[this.selectedCountryIndex].code, selectedLanguageCode).subscribe();
								this.languageMarketService.setMarket(this.countriesList[this.selectedCountryIndex].code);
								this.languageMarketService.setLanguage(selectedLanguageCode);
							}
						}
					})
				}
				this.selectedCountryIndex = this.selectedCountryIndex < 0 ? 0 : this.selectedCountryIndex;

				if (this.selectedLanguageCode &&
					this.countriesList[this.selectedCountryIndex] &&
					this.countriesList[this.selectedCountryIndex].language
				) {
					const country = this.countriesList[this.selectedCountryIndex];
					this.selectedLanguageIndex = country.language.findIndex(lang => lang.code === this.selectedLanguageCode);
				} else {
					this.languageMarketService.setLanguage(DEFAULT_LANGUAGE);
				}
				
				// get currency of selected market and save in session storage
				this.INDRA_mapCurrency();
			});
		});
		

		//if (this.isDisabledPage(this.router.url).length != 0) {
		//	this.disableMarket = true;
		//}

		this.allSubscriptions.push(this.currencySubscription);
		this.allSubscriptions.push(this.getMarketSubscription);
		this.allSubscriptions.push(this.setMarketSubscription1);

	}

	ngOnDestroy() {
		this.isAlive = false;
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}
	
	//isDisabledPage(currentURL) {
	//	const x = this.disabledPage.filter(url => {
	//		return currentURL.search(url) >= 0;
	//	});
	//
	//	return x;
	//}

	INDRA_currencyCheck(country, index, previousIndex) {
		if (this.promoCodesAndVoucher) {
			const selected = this.countriesList[index];
			const selectedMarket = this.countryCurrencyList.filter(market => market.code === selected.code);
			const invalidDiscounts = this.promoCodesAndVoucher.filter(discount => discount.currencyCode !== selectedMarket[0].currency);

			if (invalidDiscounts.length !== 0) {

				this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslationKey('header.title.changingCountry')));
				this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslationKey('header.text.invalidCountryBooking')));
				this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslationKey('header.text.continueToNewCountry')));
				this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslationKey('header.text.keepTheDiscount')));
				this.modalService.assignComponent(INDRAConfirmModalComponent);
				this.modalService.open();
				this.modalService.isOpen
					.pipe(takeWhile(() => this.isAlive))
					.subscribe(value => {
						if (!value) {
							if (this.confirmModalCallback === 'ok') {

								invalidDiscounts.forEach(discount => {

									this.removeVoucherSubscription = this.discountService.INDRA_removeVoucherInSession(discount.code).subscribe(voucher => {
										if (voucher.status === '200') {
											const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
											this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
											this.promoCodesAndVoucher = currDiscountList;
											this.currencyChecked = true;
										} else {
											this.removePromocodeSubscription = this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(promo => {
												if (promo.data || promo.status === '406') {
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
												} else {
													/** temporary remove discount in front */ 
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
												}
											}, err => {
												if (err) {
													/** temporary remove discount in front */ 
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
												}
											});
										}
									}, error => {
										if (error) {
											this.removePromocodeSubscription = this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(promo => {
												if (promo.status === '200' || promo.status === '406') {
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
												} else {
													// ** temporary remove discount in front */ 
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
												}
											}, err => {
												if (err) {
													/** temporary remove discount in front */ 
													const currDiscountList = this.promoCodesAndVoucher.filter(x => x.code !== discount.code);
													this.store.dispatch(new PromoVouchersAction.PutPromoVouchersAction(currDiscountList));
													this.promoCodesAndVoucher = currDiscountList;
													this.currencyChecked = true;
													
												}
											});
										}
									});
									
								});
								this.currencyChecked = true;
								this.INDRA_handleSaveClick();
							} else {
								this.currencyChecked = true;
								this.languageRollback = true;
								this.selectedCountryIndex = previousIndex;
								this.INDRA_handleSaveClick();
							}
						}
					});
			} else {
				this.currencyChecked = true;
				this.INDRA_handleSaveClick();
			}
		} else {
			this.currencyChecked = true;
			this.INDRA_handleSaveClick();
		}
		this.allSubscriptions.push(this.removeVoucherSubscription);
		this.allSubscriptions.push(this.removePromocodeSubscription);
		
	}
	INDRA_handleUserClick() {
		if (this.location.path() != '/booking(sidebar:market-language)') {
			return true;
		} else {
			return false;
		}
	}
	INDRA_handleCountryClick(event) {
		this.previousCountryIndex = this.selectedCountryIndex;
		this.previousLanguageIndex = this.selectedLanguageIndex;
		this.selectedCountry = event.target.value;
		this.selectedCountryIndex = event.target.selectedIndex;
		this.selectedLanguageIndex = 0;

	}

	INDRA_handleLanguageClick(index) {
		this.selectedLanguageIndex = index;
		this.changeLanguage = true;
	}

	INDRA_handleSaveClick() {
		// Update store
		// this.store.dispatch(new UserActions.PutLanguageAction(this.selectedLanguageIndex));
		// this.store.dispatch(new UserActions.PutCountryAction(this.selectedCountryIndex));
		// this.sidebarService.closeSidebar();
		
		// if (!this.shopBasketGuardService.canActivate(null, null)) {
		// 	this.sidebarService.closeSidebar();
		// 	return;
		// }

		if (!this.currencyChecked) {
			this.INDRA_currencyCheck(this.selectedCountry, this.selectedCountryIndex, this.previousCountryIndex);
		} else {
			if (this.languageRollback === true) {
				this.selectedLanguageIndex = this.previousLanguageIndex;
			} else if (!this.languageRollback && !this.changeLanguage === true) {
				this.selectedLanguageIndex = 0;
			}

			const selectedMarket = this.countriesList[this.selectedCountryIndex].code;
			const selectedLanguage = this.countriesList[this.selectedCountryIndex].language[this.selectedLanguageIndex].code;
			const defaultLanguage = this.countriesList[this.selectedCountryIndex].language[0].code;

			this.setMarketSubscription2 = this.locationService.INDRA_setBookingMarket(selectedMarket, selectedLanguage).subscribe(
				data => {
					this.languageMarketService.setMarket(selectedMarket);
					this.languageMarketService.setLanguage(selectedLanguage);
					sessionStorage.setItem('decimals', data ? data.decimals : undefined);
					
					// map currency based on selected market and get translations for the selected language fromIBE Admin
					this.INDRA_mapCurrency();
					
					this.ibeAdminService.reloadTranslations('tap', selectedLanguage);
					// window.location.reload();
					
					// Update store
					this.store.dispatch(new UserActions.PutCountryAction(this.selectedCountryIndex));
					this.store.dispatch(new UserActions.PutLanguageAction(this.selectedLanguageIndex));
					this.store.dispatch(new UserActions.PutMarketAction(this.countriesList[this.selectedCountryIndex].code));
					this.currencyChecked = false;
					this.sidebarService.closeSidebar();
					
					
				},
				err => {
					console.error(err.error);
				}
			);
			this.allSubscriptions.push(this.setMarketSubscription2);
			
			}

		
	}

	INDRA_handleBackClick() {
		this.sidebarService.closeSidebar();
	}
	
	INDRA_mapCurrency() {
		this.countryCurrencyList.forEach((market) => {
			const selected = this.countriesList[this.selectedCountryIndex];
			if (market.code === selected.code) {
				sessionStorage.setItem('currency', market.currency);
			}
		});
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
